import React from "react";
import "./css/Home.css";
import { Outlet } from "react-router-dom";

function Home() {
  window.scrollTo(0, 0)
  return (
    <div className="home">
      <div className="container-home">
        <Outlet />
        {/* <Outlet /> */}
      </div>
    </div>
  );
}

export default Home;